/**
 * @prettier
 * @flow
 */
import type { EmailAddress } from 'src/types/Id';

export function getEmailInLocalStorage(): EmailAddress | void {
    const item = window.localStorage.getItem(KEY_NAME);
    return item ? JSON.parse(item) : undefined;
}

export const KEY_NAME = 'email';
